import React from "react";
import { FieldValues, UseFormReturn, Controller } from "react-hook-form";
import FileUploadInput from "../../components/FileUploadInput/FileUploadInput";
import { FormField, TextObject, WuiltContext } from "@/shared/types";

interface FileUploadFieldProps {
  isError?: boolean;
  field: FormField;
  useFormProps: UseFormReturn<FieldValues, any>;
  isSubmitting: boolean;
  formId: string;
  uploadFileUrl: (formId?: string, sectionId?: string) => string;
  sectionId?: string;
  sectionValueId?: string;
  formSubmitSucceeded?: boolean;
  text: TextObject;
  elementId?: string;
  wuiltContext: WuiltContext;
}

const FileUploadField: React.FC<FileUploadFieldProps> = ({
  isError,
  useFormProps,
  field,
  formId,
  sectionId,
  sectionValueId,
  formSubmitSucceeded,
  uploadFileUrl,
  text,
  elementId,
  wuiltContext,
}) => {
  return (
    <Controller
      control={useFormProps?.control}
      name={field?.id}
      render={({ field: fieldProps }) => (
        <FileUploadInput
          formId={formId}
          sectionId={sectionId}
          formSubmitSucceeded={formSubmitSucceeded}
          sectionValueId={sectionValueId}
          uploadFileUrl={uploadFileUrl}
          isError={isError}
          id={field?.id}
          fieldSettings={field?.settings || {}}
          {...fieldProps}
          text={text}
          elementId={elementId!}
          wuiltContext={wuiltContext}
        />
      )}
    />
  );
};

export default FileUploadField;
